var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fadePopup"
    }
  }, [(_vm.currentArticleIndex !== '' && _vm.popupOpened) ? _c('div', {
    staticClass: "popup news-popup"
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar",
      value: ({
        preventParentScroll: true
      }),
      expression: "{preventParentScroll: true}"
    }],
    staticClass: "popup__content light-bg"
  }, [_c('div', {
    ref: "articleFull",
    staticClass: "article-full"
  }, [_c('transition', {
    attrs: {
      "name": "fadePopup"
    }
  }, [_c('div', {
    staticClass: "article-full__content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.currArr.text.item.title))]), _vm._v(" "), _c('div', {
    staticClass: "article-full__date"
  }, [_vm._v("\n              " + _vm._s(_vm.setDay(_vm.currArr.publication_datetime.$day)) + "\n              " + _vm._s(_vm.$t("months")[parseInt(_vm.currArr.publication_datetime.$month, 10) - 1]) + "\n              " + _vm._s(_vm.currArr.publication_datetime.$year) + "\n            ")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.currArr.text.item.text_content)
    }
  })])])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "popup__close",
    on: {
      "click": _vm.resetCurrentArticle
    }
  }, [_c('span', {
    staticClass: "icon-exit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "popup__controls"
  }, [_c('span', {
    staticClass: "popup__control",
    class: {
      'disabled': _vm.currentArticleIndex === 0
    },
    on: {
      "click": function($event) {
        _vm.changeCurrentArticle(_vm.currentArticleIndex - 1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "popup__control",
    class: {
      'disabled': _vm.currentArticleIndex === _vm.news.item.length - 1
    },
    on: {
      "click": function($event) {
        _vm.changeCurrentArticle(_vm.currentArticleIndex + 1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-right"
  })])])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5da296bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsPopup.vue
// module id = 196
// module chunks = 0